<template>
  <v-col align="center">
    <v-card width="1000">
      <v-card-title>
        <ProductCardHeader :product-id="product.id" title="Confirmation" />
      </v-card-title>
      <v-card-text style="color: #4F4F4F">
        <v-container v-if="!isCancellation" class="pa-0 text-left">
          <div style="text-align: start" class="pb-3 font-weight-bold">
            The changes to your subscription have been confirmed. Please ensure new users perform the following steps:
          </div>
          <ol class="pb-3">
            <li style="text-align: start">Check your email. HawkSoft will send you a link to activate your account.</li>
            <li style="text-align: start">Formstack Sign will also send you an email to set up a password.</li>
            <li style="text-align: start">Once a password is set up, restart HawkSoft CMS and begin sending documents for electronic signature.</li>
          </ol>
        </v-container>
        <v-container v-else class="pa-0 text-left">
          <div style="text-align: start" class="pb-3 font-weight-bold">
            You have cancelled {{ product.name }}
          </div>
          <div style="text-align: start">All accounts have been deactivated and users will not be able to send and receive documents for E-Signature.</div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row class="pa-3" justify="end">
          <v-btn color="#FF9E15" @click="returnToMarketplace()">Return to Marketplace</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ProductCardHeader from '@/components/products/shared/ProductCardHeader';
import productIdMappingMixin from '@/mixins/productIdMappingMixin';

export default {
  name: 'NextSteps',
  components: {
    ProductCardHeader
  },
  mixins: [productIdMappingMixin],
  computed: {
    ...mapState(['selectedInsureSignUsers']),
    ...mapGetters(['getProductByProductId']),
    product () {
      return this.getProductByProductId(this.getProductId('eSignature'));
    },
    isCancellation () {
      return this.selectedInsureSignUsers.length < 1;
    }
  },
  methods: {
    returnToMarketplace () {
      this.$router.push('/marketplace');
    }
  }
};

</script>
